import { render, staticRenderFns } from "./orderDIFOTMonthlyCollectionWidget.vue?vue&type=template&id=d4f16810&"
import script from "./orderDIFOTMonthlyCollectionWidget.vue?vue&type=script&lang=js&"
export * from "./orderDIFOTMonthlyCollectionWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports